import React from 'react';
import styled from 'styled-components';
import { utils } from '@makeship/core';
import { Paragraph } from '../../ui/typography';
import { parseFeaturedCollectionMetafields } from '../../utils/collections';
import { parseProductMetafieldsFromCollection } from '../../utils/product';
import HorizontalScroller from '../HorizontalScroller/HorizontalScroller';
import CreatorCardContainer from '../CreatorCard';

const ItemWrapper = styled.div<{ sectionName?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 0 0 auto;
  margin: 0 15px;

  &:last-child {
    padding-right: 16px;
  }

  ${({ sectionName, theme }) =>
    `
      @media screen and (min-width: ${
        sectionName === 'home_featured_creators' ? theme.breakpoints.tablet : theme.breakpoints.largeTablet
      }px) {
        &:first-child {
          margin-left: 64px;
        }
        &:last-child {
          padding-right: 64px;
        }
      }
    `}
`;

const ExtendedViewWrapper = styled.div`
  overflow: visible;
  width: 100vw;
`;

const PeekContainer = styled.div`
  position: relative;
  width: 100vw;
  overflow: visible;
  pointer-events: auto;
`;

type CreatorScrollerProps = {
  creatorCollections: CollectionEdgeResponse[];
  sectionName: string;
  isComingSoon?: boolean;
};

const CreatorScroller: React.FC<CreatorScrollerProps> = ({
  creatorCollections,
  sectionName,
  isComingSoon,
}: CreatorScrollerProps) => {
  const renderCarouselItems = () =>
    creatorCollections.map((collection) => {
      const { node } = collection;
      const { metafields } = node;
      const { creatorLogoURL, creatorAvatarURL } = parseFeaturedCollectionMetafields(metafields.edges);
      const creatorLogoSrc = creatorLogoURL || creatorAvatarURL;
      const productMetafields =
        (node?.products?.[0]?.node?.metafields as Shopify.MetafieldConnection | undefined)?.edges ?? [];
      const { launch } = parseProductMetafieldsFromCollection(productMetafields);
      const launchDate = utils.getDateLocalCustomFormat(launch || '', 'MMM DD');

      return (
        <ItemWrapper key={node?.id} sectionName={sectionName}>
          <CreatorCardContainer
            fullName={node?.title || ''}
            src={creatorLogoSrc}
            href={`/shop/creator/${node?.handle}`}
            collectionHandle={node?.handle}
            sectionName={sectionName}
          />
          {isComingSoon && !!launch && <Paragraph size="small">🗓️ {launchDate}</Paragraph>}
        </ItemWrapper>
      );
    });

  return (
    <ExtendedViewWrapper>
      <PeekContainer>
        <HorizontalScroller>{renderCarouselItems()}</HorizontalScroller>
      </PeekContainer>
    </ExtendedViewWrapper>
  );
};

export default CreatorScroller;
